export const getVehicleLocation = (cacheId) => (state) => state.location[cacheId];
